<template>
  <div style="position: relative;width: 100%;">
    <div ref="chart111" :style="{ width: width, height: height, position: 'absolute', top: top, left: left }"></div>
    <!-- 全选按钮移动到右上角 -->
    <div style="position: absolute; top: -32px; right: 10px; z-index: 10;">
      <a-checkbox
        :checked="allSelected"
        @change="onSelectAllChange"
      >全选</a-checkbox>
    </div>
    <!-- 展开/隐藏按钮留在原处不动 -->
    <div v-if="showIcon && shouldShowIcon" style="position: absolute; top: 9px; right: 10px; z-index: 10; display: flex; align-items: center;">
      <a-icon
        v-if="!showLegend"
        type="caret-right"
        style="color: aqua; font-size: 1.6rem; cursor: pointer"
        @click="setLegendShow(true)"
      />
      <a-icon
        v-else
        type="caret-down"
        style="color: aqua; font-size: 1.6rem; cursor: pointer"
        @click="setLegendShow(false)"
      />
    </div>

  </div>
</template>

<script>
import echarts from 'echarts'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
export default {
  props: {
    showIcon:{
      type:Boolean,
      default:true
    },
    width: {
      type: String,
      default: '450px',
    },
    height: {
      type: String,
      default: '280px',
    },
    top: {
      type: String,
      default: '18px',
    },
    left: {
      type: String,
      default: '0',
    },
    cacheKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chart: null,
      myChart: null,
      showLegend: false,
      smallLabelData: [],
      labelData: [],
      shouldShowIcon: true,
      allSelected: true,
    }
  },
  methods: {
    onSelectAllChange(e) {
      const checked = e.target.checked
      this.allSelected = checked
      const selected = {}
      this.labelData.forEach((item) => {
        selected[item] = checked
      })
      this.option.legend.selected = selected
      this.myChart.setOption(this.option)
      if (this.cacheKey) {
        localStorage.setItem(this.cacheKey, JSON.stringify(selected))
      }
    },
    toggleSelectAll() {
      this.allSelected = !this.allSelected
      const selected = {}
      this.labelData.forEach((item) => {
        selected[item] = this.allSelected
      })
      this.option.legend.selected = selected
      this.myChart.setOption(this.option)
      if (this.cacheKey) {
        localStorage.setItem(this.cacheKey, JSON.stringify(selected))
      }
    },
    syncSelectedState() {
      // 从 ECharts 实例获取当前的 legend selected 状态
      const currentOption = this.myChart.getOption()
      if (currentOption && currentOption.legend && currentOption.legend[0] && currentOption.legend[0].selected) {
        this.option.legend.selected = currentOption.legend[0].selected
        // 同步 allSelected 状态
        const selected = currentOption.legend[0].selected
        this.allSelected = this.labelData.every((item) => selected[item] !== false)
      }
    },
    setLegendShow(val) {
      this.showLegend = val
      // 先同步当前 selected 状态，防止折叠时丢失用户的取消选中操作
      this.syncSelectedState()
      if (val) {
        this.option.legend.data = this.labelData
      } else {
        this.option.legend.data = this.smallLabelData
      }
      this.myChart.setOption(this.option)
    },
    // 计算第一行能容纳多少个legend项
    calcFirstRowLegendCount(labelData) {
      const chartEl = this.$refs.chart111
      if (!chartEl) return 3 // fallback

      const chartWidth = chartEl.offsetWidth
      const legendLeft = chartWidth * 0.05  // legend left: 5%
      const iconRightMargin = 40  // 预留更充裕的空间给展开/收起按钮和测算冗余，防折行
      const availableWidth = chartWidth - legendLeft - iconRightMargin

      // 用 canvas 测量每个 legend 文本宽度
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = '14px "Microsoft YaHei", sans-serif'  // 与真实渲染字体一致，提高测算精度

      const itemWidth = 20   // legend.itemWidth
      const itemGap = 10     // echarts 默认 legend itemGap
      const padding = 3      // 图标与文字间距

      let usedWidth = 0
      let count = 0

      for (let i = 0; i < labelData.length; i++) {
        const textWidth = ctx.measureText(labelData[i]).width
        const totalItemWidth = itemWidth + padding + textWidth + itemGap
        if (usedWidth + totalItemWidth > availableWidth && count > 0) {
          break
        }
        usedWidth += totalItemWidth
        count++
      }

      return Math.max(count, 1) // 至少显示1个
    },
    //selectedObj 是否有自定义不显示的因子 setIndex要展示前几项
    initBarChart(popArr, time, labelData, selectedObj = undefined, setIndex = 3) {
      console.log('popArr1, time, labelData',popArr, time, labelData)
      // 将累计流量置后,默认不勾选
      let selected = {}
      let normalData = []
      let flowData = []
      
      // 1. 因子排序（累计流量排在后面）
      labelData.forEach((item) => {
        if (item.indexOf('累计流量') > -1) {
          flowData.push(item)
        } else {
          normalData.push(item)
        }
      })
      labelData = normalData.concat(flowData)

      // 2. 确定 selected 状态
      if (selectedObj) {
        selected = selectedObj
      } else {
        // 尝试从缓存读取
        let cachedSelected = null
        if (this.cacheKey) {
          try {
            const cached = localStorage.getItem(this.cacheKey)
            if (cached) {
              cachedSelected = JSON.parse(cached)
            }
          } catch (e) {
            console.error('Failed to parse cached legend selection', e)
          }
        }

        labelData.forEach((item) => {
          if (cachedSelected && cachedSelected[item] !== undefined) {
            selected[item] = cachedSelected[item]
          } else {
            // 无缓存或新因子的默认逻辑
            selected[item] = item.indexOf('累计流量') === -1
          }
        })
      }

      this.labelData = [...labelData]
      // 动态计算第一行能放多少个因子
      const firstRowCount = this.calcFirstRowLegendCount(labelData)
      let smallLabelData = labelData.splice(0, firstRowCount)
      this.smallLabelData = [...smallLabelData]
      // 动态限制 legend 宽度防止遮挡右上角全选和展开按钮
      const chartEl = this.$refs.chart111
      let legendWidth = '80%'
      if (chartEl) {
        const chartWidth = chartEl.offsetWidth
        const legendLeft = chartWidth * 0.05
        const iconRightMargin = 25
        legendWidth = (chartWidth - legendLeft - iconRightMargin) + 'px'
      }
      // 如果第一行就能放下全部因子，隐藏展开按钮
      this.shouldShowIcon = this.smallLabelData.length < this.labelData.length
      // 同步 allSelected 状态
      this.allSelected = this.labelData.every((item) => selected[item] !== false)
      //	得到仪表盘
      let arrs = []
      for (let i = 0; i < popArr.length; i++) {
        arrs.push({
          name: popArr[i].title,
          type: 'line',
          symbol: 'circle',
          showSymbol: false,
          symbolSize: 8,
          itemStyle: {
            normal: {
              // color: '#0092f6',
              // lineStyle: {
              //   color: '#0092f6',
              //   width: 1,
              // },
              areaStyle: {
                //color: '#94C9EC'
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0.4,
                    color: 'rgba(7,44,90,0.1)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(0,146,246,0.9)',
                  },
                ]),
              },
            },
          },
          data: popArr[i].data,
        })
      }
      console.log('arr',arrs)
      this.option = {
        // backgroundColor: '#11183c',
        color: [
          '#5470C6', '#91CC75', '#FAC858', '#EE6666', '#3BA272',
          '#73C0DE', '#FC8452', '#9A60B4', '#EA7CCC', '#5BC49F',
          '#F5994E', '#6DC8EC'
        ],
        grid: {
          left: '5%',
          right: '2%',
          top: '15%',
          bottom: '15%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              color: '#57617B',
            },
          },
          confine: true
        },
        legend: {
          data: this.showLegend ? this.labelData : this.smallLabelData,
          itemWidth: 20,
          itemHeight: 10,
          selected,
          textStyle: {
            fontSize: 14,
            color: '#65aaf1',
          },
          width: legendWidth,
          top: '0%',
          left: '5%',
          lineHeight: '20',
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: '#65aaf1',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#0a2b52',
                width: 1,
              },
            },
            /*axisTick:{
	            	show:false,
	            },
	            splitLine:{
	            	show:true,
		            lineStyle:{
		            	color:'#195384'
		            }
		        },*/
            data: time,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#65aaf1', //刻度线标签颜色
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#65aaf1',
              },
            },
          },
        ],
        series: arrs,
      }
      this.chart = this.$refs.chart111
      this.myChart = this.$echarts.init(this.chart)
      this.myChart.setOption(this.option)
      // 监听图例选中变化，同步 allSelected 状态
      this.myChart.on('legendselectchanged', (params) => {
        this.allSelected = this.labelData.every((item) => params.selected[item] !== false)
        if (this.cacheKey) {
          localStorage.setItem(this.cacheKey, JSON.stringify(params.selected))
        }
      })
      window.addEventListener('resize', () => {
        this.myChart.resize()
        const chartEl = this.$refs.chart111
        if (chartEl && this.option && this.option.legend) {
          const chartWidth = chartEl.offsetWidth
          const legendLeft = chartWidth * 0.05
          const iconRightMargin = 25
          const legendWidth = (chartWidth - legendLeft - iconRightMargin) + 'px'
          this.option.legend.width = legendWidth
          this.myChart.setOption(this.option)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.legend-select-all {
  /deep/ .ant-checkbox-wrapper {
    color: #65aaf1;
    font-size: 12px;
  }
}
/deep/ .ant-checkbox-wrapper {
  color: #65aaf1 !important;
  font-size: 12px;
}
</style>
